import { useCallback } from 'react';

import { useCheckoutContext } from '@zooplus/checkout-state';
import { BraintreeAuthorizationButton } from '@zooplus/payment-frontend';

import {
  getPlaceOrderData,
  placeOrder,
} from '@components/preview/preview-place-order-button/place-order-utils';
import { logError } from '@services/sentry-service';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';

const BraintreePlaceOrderButton = () => {
  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const onBraintreeApprove = useCallback(
    (deviceData: string, verifiedNonce: string) => {
      if (!deviceData || !verifiedNonce) {
        logError('Missing required information for Braintree transaction');
        return;
      }

      try {
        const parsedDeviceData = JSON.parse(deviceData);
        const correlationId = parsedDeviceData?.correlation_id;

        if (!correlationId) {
          logError('Missing correlation_id in Braintree deviceData');
          return;
        }

        const placeOrderData = getPlaceOrderData(checkoutState?.stateAttributes);
        const payload = {
          braintreeDeviceData: correlationId,
          braintreeVerifiedNonce: verifiedNonce,
          ...placeOrderData,
        };

        placeOrder(payload);
      } catch (error) {
        logError('Failed to process Braintree approval: ' + String(error));
      }
    },
    [checkoutState],
  );

  const onBraintreeError = useCallback(() => {
    // We will handle onBraintreeError in the follow-up story instead of blindly doing it
  }, []);

  return (
    <div data-testid="braintree-button-wrapper">
      <BraintreeAuthorizationButton onSubmit={onBraintreeApprove} onError={onBraintreeError} />
    </div>
  );
};

export default BraintreePlaceOrderButton;
